import colors from '../../colors';
import * as React from 'react';
import { LinkAttachment } from '../../../typedefs/store';
import styled from 'styled-components';

interface Props {
    attachment: LinkAttachment;
    openLinksExternally: boolean;
}

const LinkAttachment: React.SFC<Props> = ({ attachment, openLinksExternally }) => {
    return (
        <div className="conversations-attachment conversations-attachment-link">
            <A href={attachment.url} target={openLinksExternally ? '_blank' : '_self'}>
                {attachment.url}
            </A>
        </div>
    );
};

export default LinkAttachment;

const A = styled.a`color: ${colors.blue};`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Attachments/LinkAttachment.tsx